import script from "./TLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./TLogin.vue?vue&type=script&setup=true&lang=ts"

import "./TLogin.vue?vue&type=style&index=0&id=79f52850&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f52850"]])

export default __exports__